import { Home, Circle, Package, ShoppingCart } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useCartStore } from "../stores/useCartStore";
import { motion } from "framer-motion";

const BottomNavigation = () => {
	const location = useLocation();
	const { cart } = useCartStore();

	// מספר הפריטים בעגלה
	const cartItemsCount = cart.reduce((total, item) => total + item.quantity, 0);

	const navItems = [
		{
			path: '/',
			label: 'בית',
			icon: <Home size={20} />,
		},
		{
			path: '/category/necklaces',
			label: 'שרשראות', 
			icon: <Circle size={20} />,
		},
		{
			path: '/category/earrings',
			label: 'עגילים',
			icon: <Package size={20} />,
		},
		{
			path: '/category/bracelets',
			label: 'צמידים',
			icon: <Circle size={20} />,
			
		},
		// {
		// 	path: '/category/rings',
		// 	label: 'טבעות',
		// 	icon: <Circle size={20} />,
		// 	comingSoon: false,
		// },
		{
			path: '/cart',
			label: 'עגלה',
			icon: <ShoppingCart size={20} />,
			badge: cartItemsCount > 0 ? cartItemsCount : null,
		},
	];

	// בדיקה אם הנתיב הנוכחי פעיל
	const isActive = (path) => {
		if (path === '/') {
			return location.pathname === '/';
		}
		return location.pathname.startsWith(path);
	};

	return (
		    <nav className="fixed bottom-0 left-0 right-0 bg-gray-100 bg-opacity-70 box-shadow-md backdrop-blur-md border-t border-gray-300 z-40 md:hidden" dir="rtl">
			<div className="grid grid-cols-5 h-16">
				{navItems.map((item) => (
					item.comingSoon ? (
						<div
							key={item.path}
							className="flex flex-col items-center justify-center relative text-gray-700 cursor-not-allowed"
						>
							{/* אייקון */}
							<div className="relative">
								{item.icon}
								<div className="absolute -top-1 -right-1 w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
							</div>
							
							{/* טקסט */}
							<span className="text-xs mt-1 opacity-70">
								{item.label}
							</span>
							
							{/* הודעת בקרוב */}
							<span className="text-xs text-orange-400 opacity-80">
								בקרוב
							</span>
						</div>
					) : (
						<Link
							key={item.path}
							to={item.path}
							className={`
								flex flex-col items-center justify-center relative
								transition-all duration-300 ease-in-out
								${isActive(item.path) 
									? 'text-[#5b0c3d]' 
									: 'text-gray-700 hover:text-[#5b0c3d]'
								}
							`}
						>
						{/* אייקון עם אנימציה */}
						<motion.div
							className="relative"
							whileTap={{ scale: 0.9 }}
							animate={{ 
								scale: isActive(item.path) ? 1.1 : 1,
								y: isActive(item.path) ? -2 : 0 
							}}
							transition={{ type: "spring", stiffness: 300, damping: 20 }}
						>
							{item.icon}
							
							{/* Badge לעגלה */}
							{item.badge && (
								<motion.span
									initial={{ scale: 0 }}
									animate={{ scale: 1 }}
									className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center min-w-[20px]"
								>
									{item.badge > 99 ? '99+' : item.badge}
								</motion.span>
							)}
						</motion.div>
						
						{/* טקסט */}
						<span className={`
							text-xs mt-1 transition-all duration-300
							${isActive(item.path) ? 'opacity-100 font-medium' : 'opacity-70'}
						`}>
							{item.label}
						</span>
						
						{/* אינדיקטור פעיל */}
						{isActive(item.path) && (
							<motion.div
								layoutId="activeIndicator"
								className="absolute -top-px left-1/2 transform -translate-x-1/2 w-8 h-0.5 bg-[#5b0c3d] rounded-full"
								initial={false}
								transition={{ type: "spring", stiffness: 500, damping: 30 }}
							/>
						)}
											</Link>
					)
				))}
			</div>
		</nav>
	);
};

export default BottomNavigation; 